module.exports = __webpack_public_path__ + "static/media/paypal.e7cbcaa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/payment/paypal.png
// module id = 644
// module chunks = 0